<script lang="ts">
  import { getTypographyCss } from "../lib/helpers/typography";
  import { TypographyType } from "../lib/constants/typographyMap";

  export let desktop: TypographyType;
  export let mobile: TypographyType;
  export let copy: string | undefined = undefined;

  const style = getTypographyCss(mobile, desktop);
</script>

<div class="typography"{style}>
  {#if copy}
    {copy}
  {:else}
    <slot />
  {/if}
</div>

<style>
  .typography {
    font-feature-settings: var(--mobile-font-feature-settings);
    font-family: var(--mobile-font-family);
    font-size: var(--mobile-font-size);
    line-height: var(--mobile-line-height);
    font-weight: var(--mobile-font-weight);
    color: var(--font-color);
    letter-spacing: calc(var(--mobile-letter-spacing) * var(--mobile-font-size));
  }

  @media screen and (min-width: 1024px) {
    .typography {
      font-feature-settings: var(--desktop-font-feature-settings);
      font-family: var(--desktop-font-family);
      font-size: var(--desktop-font-size);
      line-height: var(--desktop-line-height);
      font-weight: var(--desktop-font-weight);
      color: var(--font-color);
      letter-spacing: calc(var(--desktop-letter-spacing) * var(--desktop-font-size));
    }
  }
</style>
